import React, {
    ReactElement,
} from "react";
import usePortal from "../../contexts/PortalContext";
import useRouting, { useParams, Navigate } from "../../contexts/Routing";
import { Permission } from "../../__generated__/api";
import Styles from "./Administrator.module.scss";
import WorkflowServiceCreate from "./sections/workflow-service-create/CreateService";
import FormTemplates from "./sections/form-templates/FormTemplates";
import FormFields from "./sections/form-fields/FieldTemplates";

const SECTIONS = [
    {
        name: "Workflows",
        sections: [
            {
                title: "Create Service",
                name: "Create",
                slug: "workflows",
                page: WorkflowServiceCreate,
            },

        ],
    },
    {
        name: "Forms",
        sections: [
            {
                title: "Form Templates",
                name: "Form Template",
                slug: "form-templates",
                page: FormTemplates,
            },
            {
                title: "Form Fields",
                name: "Form Fields",
                slug: "form-fields",
                page: FormFields,
            },

        ],
    },

];

const DEFAULT = SECTIONS[0].sections[0];
const FLAT_SECTIONS = SECTIONS.flatMap(row => row.sections);

export default function Administrator(): ReactElement {
    const { Paths, historyPush } = useRouting();
    let { setting } = useParams(Paths.SITE_ADMINISTRATOR_SETTING);
    const adminIdSettings = useParams(Paths.SITE_ADMINISTRATOR_SETTING_ID);

    const { permissions } = usePortal();
    if (!permissions.has(Permission.SuperAdmin)) {
        return <Navigate to={Paths.DEFAULT} />;
    }

    if (!setting) {
        setting = adminIdSettings.setting;
        if (!setting) {
            const defaultItem = FLAT_SECTIONS.find(row => row === DEFAULT);
            if (defaultItem) {
                historyPush(Paths.SITE_ADMINISTRATOR_SETTING, { setting: defaultItem.slug });
            }
        }
    }

    const container = setting ? FLAT_SECTIONS.find(page => page.slug === setting) : undefined;
    const Page = container ? container.page : undefined;

    return (

        <div className="d-flex justify-content-between align-items-stretch h-100">
            <div className={`border-end overflow-hidden flex-shrink-0 mb-4 ${Styles.sidebar}`}>
                <div className="text-center pt-3 pb-2 bg-danger">
                    <h4 className="text-white">Site Admin</h4>
                </div>
                {SECTIONS.map(group => (
                    <div key={group.name}>
                        <div className="text-center list-header border-top bg-gray-100">
                            {group.name}
                        </div>
                        <div className="list-group list-group-flush" role="tablist">
                            {group.sections.filter(section => section.name).map(section => (
                                <button
                                    key={section.slug}
                                    type="button"
                                    className={`list-group-item list-group-item-action border-start d-flex `
                                            + ` list-border ${container?.slug === section.slug ? "list-border-primary" : ""}`
                                            + ` rounded-0  align-items-center `}
                                    onClick={() => {
                                        historyPush(Paths.SITE_ADMINISTRATOR_SETTING, { setting: section.slug });
                                    }}
                                >
                                    {section.name}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}

            </div>

            <div className="flex-grow-1 p-3 d-flex flex-column ">
                {container?.title && (
                    <h5 className="mb-4">
                        {container?.title}
                    </h5>
                )}

                {Page ? <Page /> : undefined}

            </div>

        </div>

    );
}
